export default __webpack_public_path__ + "static/media/promo-banner-liquidity-mining.98b16c93.svg";